<template>
  <div class="finTools">
    <div v-if="this.$route.name === 'finTools'">
      <fin-content-section elevated>
        <template>
          <fin-tools-overview :tabs="tabs" id="fin-tools-overview"/>
        </template>
      </fin-content-section>
    </div>
    <router-view v-else/>
  </div>
</template>

<script>
import FinToolsOverview from '@/components/pages/finTools/overview/Overview'
import FinContentSection from '@/components/pages/ContentSection'

export default {
  name: 'finTools',
  components: {
    FinContentSection,
    FinToolsOverview
  },
  data () {
    return {
      elevated: false,
      tabs: [
        {
          title: 'Alle Tools',
          filteredBy: ''
        }/*,
        {
          title: 'Aktien',
          filteredBy: 'share'
        },
        {
          title: 'ETF',
          filteredBy: 'etf'
        }*/
      ]
    }
  }
}
</script>

<style scoped>

</style>
